import { render, staticRenderFns } from "./ProductConfigDialog.vue?vue&type=template&id=f87cbe3a&"
import script from "./ProductConfigDialog.vue?vue&type=script&lang=js&"
export * from "./ProductConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductConfigDialog.vue?vue&type=style&index=0&id=f87cbe3a&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports